module.exports = __webpack_public_path__ + "img/adminonly_icon_white.a19f01f5.svg";